// Implements: F-UIX-018, F-IDN-026
/**
 * `/backoffice/invitations`: Invitaciones (mockup v3 P3). The page only composes: the organization
 * comes from the session's permission answer (`invitation:issue`), the list and its writes from the
 * organization module's `InvitationsContainer`, keyed by the organization and by the person.
 */

import type { ReactElement } from "react";

import { ByOrganization } from "../../modules/organization/containers/ByOrganization";
import { InvitationsContainer } from "../../modules/organization/containers/InvitationsContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function InvitationsPage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("organization.invitations.title")} subtitle={t("organization.invitations.intro")} />
      <ByOrganization key={user.id} scopes={scopes} actions={["invitation:issue"]}>
        {(target) => <InvitationsContainer organizationId={target.organizationId} />}
      </ByOrganization>
    </section>
  );
}
